
let  indexLang =  {
    index: 'Home',
    User: 'Users',
    userlist: 'All Users',
    Account: 'Accounts',
    Report: 'Reports',
    Setting: 'Settings',
    allAccount: 'All Accounts',
    introBroker: 'Introduce Brokers',
    retailAccount: 'Retail Accounts',
    personalReport: 'Personal Report',
    ibReport: 'IB Report',
    positionReport: 'Position Report',
    tradingHistory: 'Trading History',
    discountSet: 'Rebate Setting',
    groupSet: 'User Group Setting',
    operationLog: 'Operation Log',
    newAccount: 'New Trade Account',
    dailyDeposit: 'Daily Deposit',
    dailyWithdraw: 'Daily Withdraw',
    dailyVolume: 'Daily Volume',
    monthReg: 'Monthly Register',
    volumeSta: 'Volume Statistics',
    customersActivity: 'Customers Activity',
    tradeAccount: 'Trade Account',
    volume: 'Volume',
    activeAccount: 'Active Account',
    inactiveAccount: 'Inactive Account',
    monthVolume: 'Monthly Volume',
    scale: 'Scale',
    pc: 'PC',
    fotter1: '',
    fotter2: ''
}

export default indexLang;




















































// WEBPACK FOOTER //
// ./src/i18n/english/indexLang.js